
import {map} from 'rxjs/operators';
import { EcaWindowRefService } from './../../services/window-ref/window-ref.service';
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { EcaSecurityAuthenticationService } from '../../services/security-authentication/security-authentication.service';

@Injectable({
  providedIn: 'root'
})
export class EcaAuthenticatedRedirectGuard  {
  private _ecaSecurityAuthenticationService = inject(EcaSecurityAuthenticationService);
  private _router = inject(Router);
  private _ecaWindowRefService = inject(EcaWindowRefService);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const sessionStorage = this._ecaWindowRefService.nativeWindow.sessionStorage;
    return this._ecaSecurityAuthenticationService.isAuthenticated().pipe(map(
      (authenticated) => {
        if (authenticated) {
          const redirectUrl = sessionStorage.getItem('eca_requested_route') || '';
          sessionStorage.removeItem('eca_requested_route');
          this._router.navigateByUrl(redirectUrl);
          return false;
        } else {
          return true;
        }
      }
    ));
  }
}
